import { useTranslation } from "react-i18next";
import { skipToken } from "@reduxjs/toolkit/query";

import BaseDivider from "@/components_v2/Divider/BaseDivider";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import {
  DataBlockContent,
  DataBlockDetails,
} from "@/domains/datablocks/components/DataBlockContent";
import {
  useGetDataBlockByIdQuery,
  useGetDataTemplateByIdQuery,
} from "@/redux/service";

import type { EvidencePreviewPanelProps } from "../types";

import "../styles.css";

const EvidencePreviewPanel = ({ blockId }: EvidencePreviewPanelProps) => {
  const { t } = useTranslation();

  const { data: dataBlock, isError: isBlockError } =
    useGetDataBlockByIdQuery(blockId);

  const { data: dataTemplate, isError: isTemplateError } =
    useGetDataTemplateByIdQuery(dataBlock?.template.id ?? skipToken);

  if (isBlockError || isTemplateError) {
    return (
      <p className="body-m-regular">
        {t("survey.labels.evidencePreviewLoadError")}
      </p>
    );
  }

  if (!dataBlock || !dataTemplate) {
    return (
      <div className="flex justify-center full-width">
        <BaseSpinner size="small" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-400">
      <DataBlockDetails dataBlock={dataBlock} dataTemplate={dataTemplate} />

      <BaseDivider />

      <DataBlockContent dataBlock={dataBlock} dataTemplate={dataTemplate} />
    </div>
  );
};

export default EvidencePreviewPanel;
